'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = require('mobx');

// TODO: Remove the general 'rules' and make everything locally accessable in the store.
exports.default = _mobx.observable.map({});